const MobileHeader = () => {
  return (
    <>
      <header className="mobile-header">
        <button
          className="btn-toggle"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasSidebar"
          aria-controls="offcanvasSidebar"
          aria-label="Toggle sidebar"
        >
          <i className="bi bi-list"></i>
        </button>
        <div className="brand">
          <a href="#">
            <img src="/assets/logo.png" alt="Brand Logo" width={150} />
          </a>
        </div>
      </header>
    </>
  );
};

export default MobileHeader;
